<template>
    <v-row no-gutters>
        <!-- ระดับชั้นที่ต้องการสมัคร -->
        <v-col cols="12" class="pa-4">
            <v-row no-gutters justify="space-between" class="mb-3">
                <span class="header-text">{{ $t('message.adminPage.status.status') }}</span>

                <v-btn small color="#EBEAEB">
                    <v-icon small left :color="getStatusState?.color">{{
                        getStatusState?.icon
                    }}</v-icon>
                    <span class="default-text-prompt">{{
                        getStatusState?.text
                    }}</span>
                </v-btn>
            </v-row>
            <v-row no-gutters class="my-3">
                <v-divider></v-divider>
            </v-row>
            <v-row no-gutters class="mb-4">
                <v-col cols="6">
                    <v-row no-gutters
                        ><span class="caption-text">
                            {{ $t('message.adminPage.status.dateAnnounce') }}</span
                        >
                    </v-row>
                    <v-row no-gutters
                        ><span class="default-text">{{
                            examAuthorizeAnnouncementDate
                        }}</span>
                    </v-row>
                </v-col>
                <v-col cols="6">
                    <v-row no-gutters
                        ><span class="caption-text"> {{ $t('message.adminPage.status.time') }}</span>
                    </v-row>
                    <v-row no-gutters
                        ><span class="default-text">{{
                            this.applicant?.register_form
                                ?.exam_authorize_announcement_time
                        }} {{$t('message.formSummit.time')}}</span>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters class="mb-4" v-if="checkRegistrationStatus">
                <v-col cols="12" class="mb-3">
                    <v-row no-gutters>
                        <v-icon left color="secondary">mdi-information</v-icon>
                        <span class="default-text">
                            {{$t('message.adminPage.status.resultQualified')}}
                        </span>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-btn
                        @click="onConfirmStatus('accept')"
                        width="100%"
                        rounded
                        :color="getButtonState?.submit?.color"
                        :disabled="getButtonState?.submit?.disable"
                        class="default-text-prompt"
                        >{{ getButtonState.submit?.text }}</v-btn
                    >
                </v-col>
                <v-col cols="12">
                    <v-btn
                        @click="onConfirmStatus('reject')"
                        width="100%"
                        rounded
                        :color="getButtonState?.cancel?.color"
                        :disabled="getButtonState?.cancel?.disable"
                        class="default-text-prompt"
                        >{{ getButtonState?.cancel?.text }}</v-btn
                    >
                </v-col>
            </v-row>
            <v-row no-gutters class="mb-4" v-if="checkExamUnauthorizeStatus">
                <v-col cols="12" class="mb-3">
                    <v-row no-gutters>
                        <v-icon left color="secondary">mdi-information</v-icon>
                        <span class="default-text">
                            {{$t('message.adminPage.status.resultQualified')}}
                        </span>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-btn
                        @click="onConfirmStatus('change_exam_result')"
                        width="100%"
                        rounded
                        :color="getButtonState?.submit?.color"
                        :disabled="getButtonState?.default?.disable"
                        class="default-text-prompt"
                        >{{ getButtonState.submit?.text }}</v-btn
                    >
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { RegistrationStatusEnum } from "@/constants";
import { formatDateTimeLocale } from "@/utils/date";
import i18n from '@/i18n';
export default {
    props: {
        applicantInfo: Object,
        getStatusState: Object,
        getButtonState: Object,
    },
    mounted() {
        this.retrievedData();
    },
    data() {
        return {
            applicant: {},
        };
    },
    computed: {
        locale(){
            return i18n.locale;
        },
        checkRegistrationStatus() {
            if (
                [
                    RegistrationStatusEnum.REGISTER,
                    RegistrationStatusEnum.PENDING_PAYMENT,
                    RegistrationStatusEnum.SUCCESSFUL_PAYMENT,
                ].includes(this.applicantInfo?.registrationStatus)
            )
                return true;
            return false;
        },
        examAuthorizeAnnouncementDate() {
            let newDate = Date.parse(
                this.applicant?.register_form?.exam_authorize_announcement_date
            );
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        checkExamUnauthorizeStatus() {
            return this.applicantInfo?.registrationStatus === RegistrationStatusEnum.EXAM_UNAUTHORIZE;
        },
    },
    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
        onConfirmStatus(action) {
            this.$emit("onConfirmStatus", action);
        },
    },
};
</script>

<style scoped lang="scss">
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text-prompt {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
